// extracted by mini-css-extract-plugin
export default {"container":"gq-z","ratingLayout":"hq-z","ratingLabel":"iq-z","nonInteractiveRatingLabel":"jq-z"};